import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'c3m-modal-alert',
  templateUrl: './modal-alert.component.html',
  styleUrls: ['./modal-alert.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ModalAlertComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
